import Tile from "../Tile";
import MUIGreyColor from "@mui/material/colors/grey";
import ProductType from "../../Utility/Crud/ProductType";
export default class TileProductType extends Tile {
    /**
      * @returns {string} The ProductType name.
      */
    getTitle() {
        return this.props.productType ? ProductType.getDisplayName(this.props.productType) : "None";
    }

    /**
     * @returns {string} The string to be used by the avatar abbreviation
     * formatter.
     */
    getAvatarString() {
        return this.props.productType ? ProductType.getDisplayName(this.props.productType) : null;
    }

    /**
     * @returns {string} The color of the avatar.
     */
    getAvatarColor() {
        return this.props.productType ? ProductType.getColor() : MUIGreyColor[400];
    }

    /**
     * Renders an icon to represent the avatar if no string is provided.
     */
    renderAvatarIcon() {
        return ProductType.getIcon();
    }
}
